import Typography from "@vapor/react-extended/ExtendedTypography";
import Grid from "@vapor/react-material/Grid";

const DateCell = ({ formattedDate }) => {
  return (
    <Grid item sm={6}>
      <Typography fontWeight={400} noWrap variant="body">
        {formattedDate}
      </Typography>
    </Grid>
  );
};

export default DateCell;
